/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-07-15 11:07:00
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-15 11:18:54
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/ProductsSelection/ProductSelectionWithHsCode/ProductList/hooks.ts
 */
import { getProductsByHsCode } from 'src/request/common/hsCode';
import React from 'react';
const useHsProductLoading = ({
  hsCodes,
  dangerousGoodsClasses,
  setLoading,
  isHs,
  setHsProducts,
}) => {
  const _key = React.useMemo(() => {
    const _hsCodes = hsCodes.map((i) => i.value);
    const _dangerousGoodsClasses = dangerousGoodsClasses.map((i) => i.value);
    return {
      hsCodePrefixes: _hsCodes,
      dangerousGoodsClasses: _dangerousGoodsClasses,
    };
  }, [hsCodes, dangerousGoodsClasses]);
  const hsHasData = React.useMemo(() => {
    return (
      _key.dangerousGoodsClasses.length > 0 || _key.hsCodePrefixes.length > 0
    );
  }, [_key]);

  React.useEffect(() => {
    if (isHs)
      if (hsHasData) {
        setLoading(true);
        getProductsByHsCode(_key)
          .then((res: any) => {
            setHsProducts(res);
            setLoading(false);
          })
          .catch(() => setLoading(false));
      } else {
        setHsProducts([]);
      }
  }, [_key, isHs]);
};
export { useHsProductLoading };
